import { Injectable } from '@angular/core';

import { AlertDialogComponent } from '../../components/common/alert-dialog/alert-dialog.component';
import { ConfirmDialogComponent } from '../../components/common/confirm-dialog/confirm-dialog.component';
import { ModalConfirmComponent } from '../../components/common/modal-confirm/modal-confirm.component';

@Injectable()
export class ModalService {
  alertDialogComponent: AlertDialogComponent;
  confirmDialogComponent: ConfirmDialogComponent;
  confirmModal: ModalConfirmComponent;
  constructor() {}
}
